module.exports = __webpack_public_path__ + "img/pluto31.05d909bd.jpg";